module.exports = __webpack_public_path__ + "img/logs-b.0badf533.png";